import { useState } from "react";
import { TagInput } from "rsuite";
import { Uploader } from "rsuite";
import { Button, Upload } from "antd";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import { FaCaretDown } from "react-icons/fa";
import { Dropdown } from 'primereact/dropdown';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};



function getStyles(name, personName, theme) {
  return {
    fontWeight: personName.includes(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}

function PatientMedicalInfo({ formik }) {
  const data = [
    {
      "Allergic Rhinitis (Hay Fever)": [
        "Pollen, dust mites, mold, animal dander",
        "Sneezing",
        "Runny/Blocked Nose",
        "Itchy Eyes/Nose/Throat",
        "Watery Eyes"
      ],
      "Asthma (Allergic or Non-Allergic)": [
        "Wheezing",
        "Shortness of Breath",
        "Chest Tightness",
        "Coughing"
      ],
      "Atopic Dermatitis (Eczema)": [
        "Chronic, Itchy Skin Inflammation"
      ],
      "Drug / Medication Allergies": [
        "Penicillin",
        "Cephalosporins",
        "Sulfa Drugs (Sulfonamides)",
        "Aspirin / NSAIDs ",
        "Chemotherapy Agents",
        "Local Anesthetics ",
        "Contrast Dyes (Iodine-based)"
      ],
      "Urticaria (Hives) and Angioedema": [
        "Red, Itchy Welts",
        "Swelling of Skin and Mucous Membranes"
      ],
      
      "Insect Allergies": [
        "Bee Stings",
        "Wasp Stings",
        "Hornet Stings",
        "Fire Ant Bites",
        "Mosquito Bites"
      ],
      "Others":[
        "None"
      ]
    }

  ]
  const data1 = [
    {
      "Cardiovascular Diseases": [
        "Hypertension (High Blood Pressure)",
        "Coronary Artery Disease (CAD)",
        "Heart Failure",
        "Atrial Fibrillation",
        "Myocardial Infarction (Heart Attack)",
        "Hyperlipidemia (High Cholesterol)",
        "Peripheral Artery Disease",
        "Arrhythmia",
        "Stroke",
        "Congenital Heart Disease"
      ],
      "Respiratory Conditions": [
        "Asthma",
        "Chronic Obstructive Pulmonary Disease (COPD)",
        "Tuberculosis",
        "Pneumonia",
        "Pulmonary Embolism",
        "Interstitial Lung Disease",
        "Sleep Apnea",
        "Bronchitis"
      ],
      "Gastrointestinal Conditions": [
        "Gastritis",
        "Gastroesophageal Reflux Disease (GERD)",
        "Peptic Ulcer",
        "Irritable Bowel Syndrome (IBS)",
        "Crohn’s Disease",
        "Ulcerative Colitis",
        "Hepatitis B",
        "Hepatitis C",
        "Cirrhosis",
        "Fatty Liver Disease",
        "Pancreatitis",
        "Gallstones"
      ],
      "Neurological Disorders": [
        "Epilepsy",
        "Migraine",
        "Stroke (Ischemic or Hemorrhagic)",
        "Parkinson’s Disease",
        "Alzheimer’s Disease",
        "Multiple Sclerosis",
        "Neuropathy",
        "Bell’s Palsy"
      ],
      "Musculoskeletal Conditions": [
        "Osteoarthritis",
        "Rheumatoid Arthritis",
        "Osteoporosis",
        "Gout",
        "Low Back Pain",
        "Spondylitis",
        "Fractures (History of)"
      ],
      "Endocrine & Metabolic Disorders": [
        "Diabetes Mellitus Type 1",
        "Diabetes Mellitus Type 2",
        "Hypothyroidism",
        "Hyperthyroidism",
        "Polycystic Ovary Syndrome (PCOS)",
        "Metabolic Syndrome",
        "Addison’s Disease",
        "Cushing’s Syndrome"
      ],
      "Infectious Diseases": [
        "HIV/AIDS",
        "Tuberculosis",
        "Malaria",
        "Dengue",
        "Typhoid Fever",
        "COVID-19",
        "Influenza",
        "Hepatitis A/B/C"
      ],
      "Hematologic Conditions": [
        "Anemia",
        "Thalassemia",
        "Hemophilia",
        "Leukemia",
        "Lymphoma",
        "Sickle Cell Disease"
      ],
      "Mental Health Disorders": [
        "Depression",
        "Anxiety Disorder",
        "Bipolar Disorder",
        "Schizophrenia",
        "PTSD (Post-Traumatic Stress Disorder)",
        "OCD (Obsessive-Compulsive Disorder)"
      ],
      "Reproductive / Obstetric Conditions": [
        "Pregnancy",
        "Ectopic Pregnancy",
        "Preeclampsia",
        "Gestational Diabetes",
        "Menstrual Irregularities",
        "Infertility"
      ],
      "Dermatological Conditions": [
        "Eczema",
        "Psoriasis",
        "Acne",
        "Urticaria (Hives)",
        "Vitiligo",
        "Skin Cancer"
      ],
      "Eye Conditions": [
        "Cataract",
        "Glaucoma",
        "Diabetic Retinopathy",
        "Macular Degeneration",
        "Conjunctivitis"
      ],
      "ENT Conditions": [
        "Sinusitis",
        "Otitis Media",
        "Tinnitus",
        "Tonsillitis",
        "Deviated Nasal Septum"
      ],
      "Other / General Conditions": [
        "Obesity",
        "Cancer (General or Site-specific)",
        "Autoimmune Disease",
        "Chronic Pain",
        "Fever (of unknown origin)",
        "Dehydration",
        "Sepsis"
      ],
      "Special Entries": [
        "No Known Medical Conditions",
        "Condition Not Documented",
        "Other (Specify)"
      ]
    }

  ];


  // const allergiesifany = data.map(item => ({
  //   label: item,
  //   value: item
  // }));
  const allergiesifany = Object.entries(data[0]).map(
    ([category, conditions]) => ({
      label: category,          // This becomes the heading
      items: conditions.map(cond => ({
        label: cond,            // Each item under heading
        value: cond
      }))
    })
  );


  const existingmedicalconditions = Object.entries(data1[0]).map(
    ([category, conditions]) => ({
      label: category,          // This becomes the heading
      items: conditions.map(cond => ({
        label: cond,            // Each item under heading
        value: cond
      }))
    })
  );

  const multiselectstyles = `
  .css-yi3mkw {
      height: auto;
    min-height: 1.4375em;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    flex-wrap: nowrap;
  }
  .p-inputtext{
  font-size:14px;
  color:#000;
  font-weight:300
  }
  `;

  const theme = useTheme();
  const [personName, setPersonName] = useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const [existingCond, setExistingCond] = useState();
  return (
    <>
      <style>{multiselectstyles}</style>
      <div className="row">
        <div className="col-12 d-flex flex-column align-items-start">
          <div className="col-12 d-flex">
            <h5
              className="fw-semibold h5-WOeTzEASAL"
              style={{ color: "rgb(43, 81, 147)", marginTop: "1rem" }}
            >
              Medical Information
            </h5>
          </div>
        </div>

        <div
          class="row mb-4"
          style={{ borderBottom: "1px dashed gray", paddingBottom: "1rem" }}
        >
          <div class="col-md-4 col-12">
            <div class="input-block mb-3">
              <label class="col-form-label lbl-VLJQLgvYMk">
                Admission Type<span className="text-danger">*</span>
              </label>

              <div style={{ position: "relative" }}>
                <select
                  class="form-control"
                  id="admissionType"
                  aria-hidden="true"
                  value={formik.values.addmissiontype}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  name="addmissiontype"
                >
                  <option value="">Select the Options</option>
                  <option value="inpatient">In-Patient</option>
                  <option value="outpatient">Out-Patient</option>
                </select>
                <FaCaretDown
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                    color: "#666",
                    fontSize: "1rem",
                  }}
                />
              </div>
              {formik.touched.addmissiontype &&
                formik.errors.addmissiontype && (
                  <div style={{ fontSize: "0.8rem", color: "red" }}>
                    {formik.errors.addmissiontype}
                  </div>
                )}
            </div>
          </div>

          <div className="col-md-4 col-12">
            <div className="input-block mb-3">
              <label className="col-form-label lbl-VLJQLgvYMk">
                Existing Medical Conditions<span className="text-danger">*</span>
              </label>

              <Dropdown
                name="existingmedicalconditions"
                value={formik.values.existingmedicalconditions}
                onChange={(e) => {
                  formik.setFieldValue('existingmedicalconditions', e.value);
                  if(e.value === "Other (Specify)"){
                    setExistingCond("Other");                 
                  }else{
                    setExistingCond(null);
                  }
                }}
                onBlur={formik.handleBlur}
                options={existingmedicalconditions}
                optionGroupLabel="label"
                optionGroupChildren="items"
                placeholder="Select Medical Condition"
                className="w-full md:w-10rem border p-0 text-sm h-8"
                panelClassName="text-sm"
                style={{ fontSize: '0.6rem', height: '40px', borderRadius: '10px' }}
                inputStyle={{ fontSize: '0.4rem' }}
                filter
                showClear
              />
              {existingCond !== "Other" && formik.touched.existingmedicalconditions && formik.errors.existingmedicalconditions && (
                <div style={{ fontSize: '0.8rem', color: 'red', }}>
                  {formik.errors.existingmedicalconditions}
                </div>
              ) }
            </div>
          </div>

          
          {existingCond === "Other" && <div className="col-md-4 col-12">
            <div className="input-block mb-3">
              <label className="col-form-label lbl-VLJQLgvYMk">
                Other Medical Conditions<span className="text-danger">*</span>
              </label>
               <input name="existingmedicalconditions"
                value={formik.values.existingmedicalconditions}
                onChange={(e) => formik.setFieldValue('existingmedicalconditions', e.target.value)}
                onBlur={formik.handleBlur}
                optionGroupLabel="label"
                optionGroupChildren="items"
                placeholder="Enter Medical Condition"
                className="form-control"
                panelClassName="text-sm"
                style={{ fontSize: '0.9rem', minHeight: '40px', borderRadius: '10px' }}
                filter
                showClear />  
                {formik.touched.existingmedicalconditions && formik.errors.existingmedicalconditions && (
                <div style={{ fontSize: '0.8rem', color: 'red', }}>
                  {formik.errors.existingmedicalconditions}
                </div>
              )}              
              </div>
              </div>}
              


          <div className="col-md-4 col-12">
            <div className="input-block mb-3">
              <label className="col-form-label lbl-VLJQLgvYMk">
                Allergies (if any)
              </label>

              <Dropdown
                name="allergiesifany"
                value={formik.values.allergiesifany}
                onChange={(e) => formik.setFieldValue('allergiesifany', e.value)}
                onBlur={formik.handleBlur}
                options={allergiesifany}
                optionGroupLabel="label"
                optionGroupChildren="items"
                placeholder="Allergies"
                className="w-full md:w-10rem border p-0 text-sm h-8"
                panelClassName="text-sm"
                style={{ fontSize: '0.6rem', height: '40px', borderRadius: '10px' }}
                inputStyle={{ fontSize: '0.4rem' }}
                filter
                showClear
              />

              {formik.touched.allergiesifany && formik.errors.allergiesifany && (
                <div style={{ fontSize: '0.8rem', color: 'red', marginTop: '3px' }}>
                  {formik.errors.allergiesifany}
                </div>
              )}
            </div>
          </div>

        </div>

       
        <h5>Vitals</h5>
        <div class="col-md-3 col-12">
          <div class="input-block mb-3">
            <label class="col-form-label lbl-VLJQLgvYMk">Blood Group</label>

            <div style={{ position: "relative" }}>
              <select
                class="form-control"
                id="bloodgroup"
                aria-hidden="true"
                value={formik.values.bloodgroup}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name="bloodgroup"
                style={{borderRadius:'4px'}}
              >
                <option value="">Select Blood Group</option>
                <option value="A+">A+</option>
                <option value="A-">A-</option>
                <option value="B+">B+</option>
                <option value="B-">B-</option>
                <option value="AB+">AB+</option>
                <option value="AB-">AB-</option>
                <option value="O+">O+</option>
                <option value="O-">O-</option>
              </select>
              <FaCaretDown
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "#666",
                  fontSize: "1rem",
                }}
              />
            </div>
            {formik.touched.bloodgroup && formik.errors.bloodgroup && (
              <div style={{ fontSize: "0.8rem", color: "red" }}>
                {formik.errors.bloodgroup}
              </div>
            )}
          </div>
        </div>

        <div class="col-md-3 col-12">
          <div class="input-block mb-3">
            <label class="col-form-label lbl-VLJQLgvYMk">
              Blood Pressure
            </label>
            <div style={{ position: "relative" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Blood Pressure"
                value={formik.values.bloodpressure}
                autoComplete="off"
                name="bloodpressure"
                onChange={(e) => {
                  const cleanedValue = e.target.value.replace(/[^0-9/]/g, "");
                  formik.setFieldValue("bloodpressure", cleanedValue);
                }}
                onBlur={formik.handleBlur}
                style={{ paddingRight: "2.5rem" }}
              />

              <span
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "#666",
                  fontSize: "1rem",
                }}
              >
                mmHg
              </span>
            </div>
            {formik.touched.bloodpressure && formik.errors.bloodpressure && (
              <div style={{ fontSize: "0.8rem", color: "red" }}>
                {formik.errors.bloodpressure}
              </div>
            )}
          </div>
        </div>

      
        <div class="col-md-3 col-12">
          <div class="input-block mb-3">
            <label class="col-form-label lbl-VLJQLgvYMk">
              Weight
            </label>
            <div style={{ position: "relative" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Weight"
                autoComplete="off"
                value={formik.values.weight}
                name="weight"
                onChange={(e) => {
                  const cleanedValue = e.target.value.replace(/[^0-9]/g, "");
                  formik.setFieldValue("weight", cleanedValue);
                }}
                onBlur={formik.handleBlur}
                style={{ paddingRight: "2.5rem" }}
              />

              <span
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "#666",
                  fontSize: "1rem",
                }}
              >
                kg
              </span>
            </div>
            {formik.touched.weight && formik.errors.weight && (
              <div style={{ fontSize: "0.8rem", color: "red" }}>
                {formik.errors.weight}
              </div>
            )}
          </div>
        </div>

        <div class="col-md-3 col-12">
          <div class="input-block mb-3">
            <label class="col-form-label lbl-VLJQLgvYMk">Height</label>
            <div style={{ position: "relative" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Height"
                autoComplete="off"
                value={formik.values.height}
                name="height"
                onChange={(e) => {
                  const cleanedValue = e.target.value.replace(/[^0-9]/g, "");
                  formik.setFieldValue("height", cleanedValue);
                }}
                onBlur={formik.handleBlur}
                style={{ paddingRight: "2.5rem" }}
              />

              <span
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "#666",
                  fontSize: "1rem",
                }}
              >
                cm
              </span>
            </div>
            {formik.touched.height && formik.errors.height && (
              <div style={{ fontSize: "0.8rem", color: "red" }}>
                {formik.errors.height}
              </div>
            )}
          </div>
        </div>

        <div class="col-md-3 col-12">
          <div class="input-block mb-3">
            <label class="col-form-label lbl-VLJQLgvYMk">
              Pulse
            </label>
            <div style={{ position: "relative" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Pulse"
                autoComplete="off"
                value={formik.values.pulse}
                name="pulse"
                onChange={(e) => {
                  const cleanedValue = e.target.value.replace(/[^0-9]/g, "");
                  formik.setFieldValue("pulse", cleanedValue);
                }}
                onBlur={formik.handleBlur}
                style={{ paddingRight: "2.5rem" }}
              />

              <span
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "#666",
                  fontSize: "1rem",
                }}
              >
                bpm
              </span>
            </div>
            {formik.touched.pulse && formik.errors.pulse && (
              <div style={{ fontSize: "0.8rem", color: "red" }}>
                {formik.errors.pulse}
              </div>
            )}
          </div>
        </div>

        <div class="col-md-3 col-12">
          <div class="input-block mb-3">
            <label class="col-form-label lbl-VLJQLgvYMk">
              Temparature<span className="text-danger">*</span>
            </label>
            <div style={{ position: "relative" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Temperature"
                autoComplete="off"
                value={formik.values.temparature}
                name="temparature"
                onChange={(e) => {
                  const cleanedValue = e.target.value.replace(/[^0-9.]/g, "");
                  formik.setFieldValue("temparature", cleanedValue);
                }}
                onBlur={formik.handleBlur}
                style={{ paddingRight: "2.5rem" }}
              />

              <span
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "#666",
                  fontSize: "1rem",
                }}
              >
                °C
              </span>
            </div>
            {formik.touched.temparature && formik.errors.temparature && (
              <div style={{ fontSize: "0.8rem", color: "red" }}>
                {formik.errors.temparature}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default PatientMedicalInfo;
